<template>
  <v-layout
    row
    align-center
    justify-center
  >
    <v-flex
      xs12
      sm7
      md5
      lg4
      class="mt-4"
    >
      <v-card class="elevation-12">
        <v-card-text>
          <v-form>
             {{ this.translate(messageid) }}
          </v-form>
        </v-card-text>
        
      </v-card>
    </v-flex>
  </v-layout>
</template>

<script>  

//import config from '@/config'

export default {
    data(){
        return {
            
            username:'',
            // todo: investigate feasibility.
            redirectUrl:window.location.origin + '/' + '#' + '/' + 'SetPassword',      
        };
    },
    props:{
      messageid: 'label.Welcome'
    },

    methods: {
       
    },
    created()
    {      
      this.messageid = this.$route.params.messageid
    }

};
</script>